import { CatalogItem } from "@/types/supplier";
import { WEEKDAY } from "@/types/enum/general";
import { SORT_METHOD } from "@/types/enum/propEnum";

const weekdayOrder = Object.values(WEEKDAY)

export const weekdaySort = (a: WEEKDAY, b: WEEKDAY): number => {
    return weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b)
}

export const catalogSort = (sortMethod: SORT_METHOD, catalogData: CatalogItem[]): CatalogItem[] => {
    if (sortMethod === SORT_METHOD.ALPH_DESC) {
        return catalogData.sort((a, b) => (a.name ?? 'z') > (b.name ?? 'z') ? 0 : 1)
    }

    return catalogData.sort((a, b) => (a.name ?? 'z') > (b.name ?? 'z') ? 1 : 0)
}

export function shuffleArray<T>(items: readonly T[]): T[] {
    const array = [...items];

    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));

        [array[i], array[j]] = [array[j], array[i]];
    }

    return array;
}

export function repeatSort(previous: any[], next: any[], getKey: (item: any) => string | number) {
    const prevIndex = new Map(previous.map((item, i) => [getKey(item), i]))

    return [...next].sort((a, b) => {
        const ai = prevIndex.get(getKey(a)) ?? Number.MAX_SAFE_INTEGER
        const bi = prevIndex.get(getKey(b)) ?? Number.MAX_SAFE_INTEGER
        return ai - bi
    })
}